import React, { ReactNode } from 'react';
import { Provider, ReactReduxContext } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { routerHistory } from './store/rootReducer';
import store from './store';
import Router from './components/router';
import Notifications from './components/common/notifications';
import { FavIcon } from './components/common/favIcon';
import { DocumentTitle } from './components/common/documentTitle';
import { RecaptchaProvider } from './components/recaptcha';
import { RecaptchaTarget } from './components/recaptcha/recaptchaTarget';

class App extends React.Component {
  async componentDidMount(): Promise<void> {
    if (!('scrollBehavior' in document.documentElement.style)) {
      await import('scroll-behavior-polyfill');
    }
  }
  render(): ReactNode {
    return (
      <>
        <DocumentTitle />
        <FavIcon />
        <Provider store={store} context={ReactReduxContext}>
          <RecaptchaProvider>
            <ConnectedRouter history={routerHistory} context={ReactReduxContext}>
              <Router />
            </ConnectedRouter>
            <Notifications />
            <RecaptchaTarget />
          </RecaptchaProvider>
        </Provider>
      </>
    );
  }
}

export default App;
